<template>
  <div class="zoom-resetter">
    <button
      :disabled="zoom === $options.defaultZoom"
      class="zoom-resetter__btn btn btn--primary btn--small"
      @click="onResetZoomRequested"
    >
      {{ $t('wizard_step.zoom.reset_zoom_btn_label') }}
    </button>
  </div>
</template>

<script>
  import { mapConfigIds, mapConfigList } from '@/assets/js/model/map-config'

  export default {
    props: {
      zoom: {
        type: Number,
        required: true,
      },
    },
    methods: {
      onResetZoomRequested() {
        this.$emit('update', this.$options.defaultZoom)
      },
    },
    defaultZoom: mapConfigList.find(({ id }) => id === mapConfigIds.CUSTOM_WIZARD).zoom,
  }
</script>

<style lang="scss" src="./_zoom-resetter.scss" />
